module.exports = __webpack_public_path__ + "img/back pocket entry length.1bf6b0ec.png";